import { render, staticRenderFns } from "./TopicAnswerSingle.vue?vue&type=template&id=2098ecc0&scoped=true&"
import script from "./TopicAnswerSingle.vue?vue&type=script&lang=js&"
export * from "./TopicAnswerSingle.vue?vue&type=script&lang=js&"
import style0 from "./TopicAnswerSingle.vue?vue&type=style&index=0&id=2098ecc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098ecc0",
  null
  
)

export default component.exports